module.exports = __webpack_public_path__ + "media/images/flags/TG-9c8a64700f71ce58d414fed3b2b45b39.svg";